import { FileArray } from '@aperturerobotics/chonky';
import { CustomFileMap, GALLERY_ROOT_ID } from './useGalleryFileMap';
import { useMemo } from 'react';

export const useFolderChain = (
  fileMap: CustomFileMap,
  currentFolderId: string
): FileArray => {
  return useMemo(() => {
    const folderId = currentFolderId || GALLERY_ROOT_ID;
    const currentFolder = fileMap?.[folderId] ?? fileMap?.[GALLERY_ROOT_ID];
    if (!currentFolder) {
      return [];
    }

    const folderChain = [currentFolder];

    let parentId = currentFolder.parentId;
    while (parentId) {
      const parentFile = fileMap[parentId];
      if (parentFile) {
        folderChain.unshift(parentFile);
        parentId = parentFile.parentId;
      } else {
        break;
      }
    }

    return folderChain;
  }, [currentFolderId, fileMap]);
};
